export const getCurrentTabSelectedData =
  () =>
  ({ autoOrderSamples = {}, search = {}, order = {} }) => {
    const { tabValue = '' } = order
    return tabValue === 'READYTOORDER'
      ? autoOrderSamples?.selectedData
      : search?.selectedData
  }
